import { render, staticRenderFns } from "./ContattoFilter.vue?vue&type=template&id=3c82b0d4&"
import script from "./ContattoFilter.vue?vue&type=script&lang=ts&"
export * from "./ContattoFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports